import { render, staticRenderFns } from "./LawyersEdit.vue?vue&type=template&id=18cc8360&"
import script from "./LawyersEdit.vue?vue&type=script&lang=js&"
export * from "./LawyersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports